import { render } from "./UserFormDrawer.vue?vue&type=template&id=41c2f106"
import script from "./UserFormDrawer.vue?vue&type=script&lang=js"
export * from "./UserFormDrawer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__